module.exports = __webpack_public_path__ + "img/database (1).92eab4fe.png";